var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"width":"100% !important","height":"40%","min-height":"40% !important"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{ref:"chartdiv",staticClass:"amchartDiv"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }